module.exports = __webpack_public_path__ + "static/media/bg6.672ff685.png";